// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form .item {
  display: inline-flex;
}
.form .item .label {
  min-width: 7rem;
}
.form .item .value {
  flex: 1;
}
.form .buttons {
  padding: 1rem 0rem 1rem 0rem;
  width: -webkit-fill-available;
  justify-content: center !important;
}

.small {
  margin-left: 90px;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/user-management/components/user-password/user-password.component.scss"],"names":[],"mappings":"AACC;EACC,oBAAA;AAAF;AACE;EACC,eAAA;AACH;AACE;EACC,OAAA;AACH;AAEC;EACC,4BAAA;EACA,6BAAA;EACA,kCAAA;AAAF;;AAIA;EACC,iBAAA;AADD","sourcesContent":[".form\t{ \n\t.item {\n\t\tdisplay\t: inline-flex;\n\t\t.label\t{\n\t\t\tmin-width\t\t: 7rem;\n\t\t}\n\t\t.value {\n\t\t\tflex\t\t\t: 1;\n\t\t}\n\t}\n\t.buttons {\n\t\tpadding\t\t\t\t: 1rem 0rem 1rem 0rem;\n\t\twidth\t\t\t\t: -webkit-fill-available;\n\t\tjustify-content\t\t: center !important;\n\t}\n}\n\n.small{\n\tmargin-left: 90px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
